import {connect} from 'react-redux';
import Loader from '../components/Loader';
import mapStateToProps from '../selectors';

export default connect(mapStateToProps)(Loader);